<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />{{ titleItem }}
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="segment"
          :subtitle="subtitle"
          :heightCard="heightCard"
          :openDialog="openDialog"
          @goToItem="goToElement"
          :title="title"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :showReuse="true"
          :showDelRelation="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="segment"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          :goToItem="goToElement"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :showReuse="true"
          :showDelRelation="true"
        />
      </div>
    </v-col>
    <v-dialog
      v-model="openSegment"
      max-width="600px"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        :items="dataSegment"
        @save="saveForm"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
        :show="true"
        :itemsSelect="dataSelected"
        :itemsSlider="dataSegmentSlider"
        @changeSlider="changeSlider"
        :titleItem="titleItem"
      />
    </v-dialog>
    <v-dialog
      v-model="openReuseSegment"
      max-width="600px"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        :items="dataReuseSegment"
        @save="saveReuseSegment"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
        :show="true"
        :itemsSelect="dataReuseSelected"
        :titleItem="titleItem"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'500px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>
<script>
import schedules from "@/store/horarios/schedules";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Loader from "@/components/Complement/Loader.vue";

export default {
  components: {
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },

  data() {
    return {
      showCard: true,
      title: "Segmentos",
      titleTable: "Horarios_Segmentos",
      subtitle: "Número de secuencia: ",
      color: "",
      titleDelete: "",
      itemInfo: null,
      headers: [
        {
          text: "Segmento",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Número de secuencia",
          value: "sequenceNumber",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Días",
          value: "days",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desp. de Jornada",
          value: "despl",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Tipo de jornada",
          value: "typeJor",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "150px",
        },
      ],
      dataSegmentSlider: [
        {
          name: "desplJor",
          label: "Desplazamiento de jornada",
          data: 0,
          type: "text",
          max: 720,
          min: -720,
          tooltip: this.$tc("schedules.alertDesp"),
          rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
        },
      ],
      dataSegment: [
        {
          name: "name",
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },
        {
          name: "days",
          label: "Días",
          data: null,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 365) || this.$tc("schedules.rulesDataSegment"),
          ],
        },
        {
          name: "sequence",
          label: "Secuencia",
          data: null,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 1000) ||
              this.$tc("schedules.rulesSegmentSequence"),
          ],
        },
      ],
      dataReuseSegment: [
        {
          name: "sequence",
          label: "Secuencia",
          data: null,
          type: "number",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              (v >= 1 && v <= 1000) ||
              this.$tc("schedules.rulesSegmentSequence"),
          ],
        },
      ],
      maxWidth: "600px",
      heightCard: "180px",
      dataSelected: [
        {
          name: "jor",
          label: this.$tc("schedules.typeJor"),
          data: 0,
          items: [
            { id: 0, name: "Extendida" },
            { id: 1, name: "Dividida" },
            { id: 2, name: "Truncada" },
          ],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ],
      typeForm: "",
      slider: { desplJor: 0 },
      itemToDelete: null,
      itemId: null,
      alert: false,
      textAlert: "",
      numberSequence: null,
      isLoading: false,
    };
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    segment() {
      return schedules.state.segments
        .map((segment) => {
          const elements =
            segment.elements?.map((element) => element.name) || [];
          const sequence = segment.sequenceNumber;
          return {
            ...segment,
            chips: elements,
            subtitle: sequence,
          };
        })
        .sort((a, b) => a.sequenceNumber - b.sequenceNumber); // 👈 orden numérico ascendente
    },

    segmentAll() {
      const currentSegmIds = this.segment.map((s) => s.segmId);

      return schedules.state.segmentsAll.filter(
        (item) => !currentSegmIds.includes(item.segmId),
      );
    },

    dataReuseSelected() {
      return [
        {
          name: "segment",
          label: "Segmento a reutilizar",
          data: null,
          items: this.segmentAll,
          itemsValue: "segmId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },

    padding() {
      return schedules.state.paddingNav;
    },
    openSegment: {
      get() {
        return schedules.state.openSegment.value;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openReuseSegment: {
      get() {
        return schedules.state.openReuseSegment.value;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return schedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return schedules.state.openDeleteSeg;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    titleItem() {
      const schedule = schedules.state.schedules.find(
        (schedule) => schedule.id === schedules.state.scheduleId,
      );
      return schedule ? schedule.name : "Horario";
    },
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  methods: {
    async refreshItems() {
      await schedules.dispatch("getSegments");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveReuseSegment(items) {
      let payload = {
        segment: Number(items.segment),
        sequence: Number(items.sequence),
        schedule: schedules.state.scheduleId,
      };
      this.addReuseSegment(payload);
    },
    saveForm(items) {
      const type = schedules.state.openSegment;
      let payload = {
        ...items,
        ...this.slider,
        schedule: schedules.state.scheduleId,
      };
      if (type.type == "tree") {
        this.addSegment(payload);
      }

      switch (this.typeForm) {
        case "add":
          this.addSegment(payload);
          break;
        case "edit":
          this.editSegment(payload);
          break;
        default:
          break;
      }
    },
    changeSlider(item) {
      this.slider = item;
    },
    goToSchedule() {
      schedules.dispatch("handleShowWindow", "schedule");
    },
    reset(value) {
      if (this.typeForm !== "delete") {
        schedules.commit("setOpenSegment", value);
        schedules.commit("setOpenReuseSegment", value);
        this.dataSelected.forEach((item) => {
          item.data = 0;
        });
        this.dataSegment.forEach((item) => {
          if (item.name == "name") {
            item.data = "";
          } else {
            item.data = null;
          }
        });
        this.dataReuseSegment.forEach((item) => {
          if (item.name == "name") {
            item.data = "";
          } else {
            item.data = null;
          }
        });
        this.dataReuseSelected.forEach((item) => {
          item.data = null;
        });
        this.dataSegmentSlider.forEach((item) => {
          item.data = 0;
        });
        this.slider = { desplJor: 0 };
      }
      this.alert = false;
    },
    async openDialog(type, item, event) {
      this.typeForm = type;
      let payload = {
        type: "card",
        value: true,
      };
      switch (this.typeForm) {
        case "reuse":
          await schedules.dispatch("getSegmentsAll");
          schedules.commit("setMode", this.$tc("schedules.reuseSegment"));
          schedules.commit("setOpenReuseSegment", payload);
          break;
        case "add":
          schedules.commit("setMode", this.$tc("schedules.addSegment"));
          schedules.commit("setOpenSegment", payload);
          break;
        case "edit":
          this.numberSequence = item.sequenceNumber;
          if (event) {
            event.stopPropagation();
          }
          this.itemInfo = item.elements;
          schedules.commit("setMode", this.$tc("schedules.editSegment"));
          this.dataSelected[0].data = item.typeJor;
          this.dataSegment[0].data = item.name;
          this.dataSegment[1].data = item.days;
          this.dataSegment[2].data = item.sequenceNumber;
          this.dataSegmentSlider[0].data = item.despl;
          this.itemId = item.segmId;
          schedules.commit("setOpenSegment", payload);
          break;
        case "deleteRelation":
          this.titleDelete = this.$tc("schedules.deleteRelationConfirm");
          if (event) {
            event.stopPropagation();
          }
          schedules.commit("setOpenDeleteSeg", true);
          this.itemToDelete = item;
          break;
        case "delete":
          this.titleDelete = this.$tc("schedules.toSegment");
          if (event) {
            event.stopPropagation();
          }
          schedules.commit("setOpenDeleteSeg", true);
          this.itemToDelete = item.segmId;
          break;
        default:
          break;
      }
    },

    goToElement(item) {
      schedules.commit("setSegmentId", item.segmId);
      schedules.dispatch("handleShowWindow", "element");
    },
    cardView(value) {
      this.showCard = value;
    },
    addReuseSegment(items) {
      this.isLoading = true;
      schedules.commit("setNewSegment", items);
      schedules
        .dispatch("addReuseSegment")
        .then(() => {
          this.isLoading = false;
          schedules.commit("setOpenReuseSegment", false);
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addSegmentAlert");
        })
        .catch((e) => {
          this.isLoading = false;
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.refreshItems();
      this.reset(false);
    },
    addSegment(items) {
      this.isLoading = true;
      schedules.commit("setNewSegment", items);
      schedules
        .dispatch("newSegment")
        .then(() => {
          this.isLoading = false;
          schedules.commit("setOpenSegment", false);
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addSegmentAlert");
        })
        .catch((e) => {
          this.isLoading = false;
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    editSegment(items) {
      let payload = {
        ...items,
        segmId: this.itemId,
        numberSequenceOld: this.numberSequence,
      };
      payload.elements = this.itemInfo;
      schedules.commit("setEditSegment", payload);
      schedules
        .dispatch("editSegment")
        .then(() => {
          if (this.numberSequence !== Number(items.sequence)) {
            schedules.dispatch("editSequence");
          }
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.editSegmentAlert");
        })
        .catch((e) => {
          this.color = "#FF8D58";
          this.alert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    deleteItem() {
      this.isLoading = true;
      if (this.titleDelete === this.$tc("schedules.deleteRelationConfirm")) {
        schedules.commit("setItemDelete", {
          segmId: this.itemToDelete.segmId,
          scheduleId: this.itemToDelete.scheduleId,
          numberSequence: this.itemToDelete.sequenceNumber,
        });
        schedules
          .dispatch("deleteSegmentRelation")
          .then(() => {
            this.isLoading = false;
            this.refreshItems();
            this.openDelete = false;
            schedules.commit("setOpenDeleteSeg", false);
            this.alert = true;
            this.color = "#82A1D0";
            this.textAlert = this.$tc("schedules.deleteRelationAlert");
          })
          .catch((e) => {
            this.isLoading = false;
            this.color = "#FF8D58";
            this.alert = true;
            this.textAlert = e.response.data.error.message;
          });
        this.cancelDelete();
      } else {
        schedules.commit("setItemDelete", this.itemToDelete);
        schedules
          .dispatch("deleteSegment")
          .then(() => {
            this.isLoading = false;
            this.openDelete = false;
            schedules.commit("setOpenDeleteSeg", false);
            this.alert = true;
            this.color = "#82A1D0";
            this.textAlert = this.$tc("schedules.deleteSegment");
          })
          .catch((e) => {
            this.isLoading = false;
            this.color = "#FF8D58";
            this.alert = true;
            this.textAlert = e.response.data.error.message;
          });
        this.cancelDelete();
      }
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeleteSeg", false);
    },
  },
};
</script>
<style scoped></style>
